import { S3Client } from "@aws-sdk/client-s3";
import { getEnvs } from "../utils";

const { VITE_ACCESS_KEY_ID_AWS, VITE_SECRET_ACCESS_KEY_AWS, VITE_API_URL_AWS } = getEnvs();

export const s3Client = new S3Client({
  endpoint: VITE_API_URL_AWS,
  region: 'us-east-1',
  credentials: {
    accessKeyId: VITE_ACCESS_KEY_ID_AWS,
    secretAccessKey: VITE_SECRET_ACCESS_KEY_AWS,
  },
  forcePathStyle: true,
  // Evita el middleware de autenticación S3 Express (default en el SDK),
  // que rompe el presignado de URLs con credenciales de MinIO cortas.
  disableS3ExpressSessionAuth: true,
});